export default function LiquidityBody(props) {
  return <div className="liquidity-body">{props.children}</div>;
}
